/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionLanguageEnum } from './InformationExtractionLanguageEnum';
import {
  InformationExtractionLanguageEnumFromJSON,
  InformationExtractionLanguageEnumFromJSONTyped,
  InformationExtractionLanguageEnumToJSON,
} from './InformationExtractionLanguageEnum';
import type { InformationExtractionDataset } from './InformationExtractionDataset';
import {
  InformationExtractionDatasetFromJSON,
  InformationExtractionDatasetFromJSONTyped,
  InformationExtractionDatasetToJSON,
} from './InformationExtractionDataset';

/**
 *
 * @export
 * @interface InformationExtractionGenerationInputs
 */
export interface InformationExtractionGenerationInputs {
  /**
   *
   * @type {number}
   * @memberof InformationExtractionGenerationInputs
   */
  readonly id: number;
  /**
   *
   * @type {InformationExtractionLanguageEnum}
   * @memberof InformationExtractionGenerationInputs
   */
  language?: InformationExtractionLanguageEnum;
  /**
   *
   * @type {number}
   * @memberof InformationExtractionGenerationInputs
   */
  minNumSamples?: number;
  /**
   *
   * @type {number}
   * @memberof InformationExtractionGenerationInputs
   */
  maxNumAttempts?: number;
  /**
   *
   * @type {number}
   * @memberof InformationExtractionGenerationInputs
   */
  maxWorkers?: number;
  /**
   *
   * @type {boolean}
   * @memberof InformationExtractionGenerationInputs
   */
  verifySamples?: boolean;
  /**
   *
   * @type {InformationExtractionDataset}
   * @memberof InformationExtractionGenerationInputs
   */
  seedDocuments: InformationExtractionDataset;
}

/**
 * Check if a given object implements the InformationExtractionGenerationInputs interface.
 */
export function instanceOfInformationExtractionGenerationInputs(
  value: object,
): value is InformationExtractionGenerationInputs {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('seedDocuments' in value) || value['seedDocuments'] === undefined) return false;
  return true;
}

export function InformationExtractionGenerationInputsFromJSON(json: any): InformationExtractionGenerationInputs {
  return InformationExtractionGenerationInputsFromJSONTyped(json, false);
}

export function InformationExtractionGenerationInputsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InformationExtractionGenerationInputs {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    language: json['language'] == null ? undefined : InformationExtractionLanguageEnumFromJSON(json['language']),
    minNumSamples: json['min_num_samples'] == null ? undefined : json['min_num_samples'],
    maxNumAttempts: json['max_num_attempts'] == null ? undefined : json['max_num_attempts'],
    maxWorkers: json['max_workers'] == null ? undefined : json['max_workers'],
    verifySamples: json['verify_samples'] == null ? undefined : json['verify_samples'],
    seedDocuments: InformationExtractionDatasetFromJSON(json['seed_documents']),
  };
}

export function InformationExtractionGenerationInputsToJSON(
  value?: Omit<InformationExtractionGenerationInputs, 'id'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    language: InformationExtractionLanguageEnumToJSON(value['language']),
    min_num_samples: value['minNumSamples'],
    max_num_attempts: value['maxNumAttempts'],
    max_workers: value['maxWorkers'],
    verify_samples: value['verifySamples'],
    seed_documents: InformationExtractionDatasetToJSON(value['seedDocuments']),
  };
}
